import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerComponent } from './date-picker.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DatePickerComponent],
  imports: [CommonModule, TranslateModule],
  exports: [DatePickerComponent],
})
export class DatePickerModule {}
